import { Component } from '@angular/core';
import { HttpService } from 'src/app/http.service';
import { BusinessTypeWiseProductDiscountEditDialogComponent } from '../business-type-wise-product-discount-edit-dialog/business-type-wise-product-discount-edit-dialog.component';
import { MatDialog} from '@angular/material/dialog';

@Component({
  selector: 'app-business-type-wise-product-discount',
  templateUrl: './business-type-wise-product-discount.component.html',
  styleUrls: ['./business-type-wise-product-discount.component.scss']
})
export class BusinessTypeWiseProductDiscountComponent {
  discount_products = [];
  business_types = [];
  discount_price = {};

  constructor(private http: HttpService, public dialog: MatDialog) {
    this.getBusinessTypeWiseDiscountProduct();
    this.getDiscountBusiness();
    this.getBusinessWiseDiscountPriceDict();
  }
  getBusinessTypeWiseDiscountProduct() {
    this.http.getBusinessTypeWiseDiscountProduct().subscribe((data: []) => {
      console.log(data);
      this.discount_products = data;
    }, (error) => {
      console.log(error);
    });
  }

  getDiscountBusiness() {
    this.http.getBusinessTypeWiseDiscountBusiness().subscribe((data: []) => {
      console.log(data);
      this.business_types = data;
    }, (error) => {
      console.log(error);
    });
  }

  getBusinessWiseDiscountPriceDict() {
    this.http.getBusinessTypeWiseDiscountPriceDict().subscribe((data) => {
      console.log(data);
      this.discount_price = data;
    }, (error) => {
      console.log(error);
    });
  }

  openDialog(business_type_id: number, business_type_name: string, product_id: number, product_name: string, discount_price: number): void {
    console.log('dialog open');

    const dialogRef = this.dialog.open(BusinessTypeWiseProductDiscountEditDialogComponent, {
      height: '400px',
      width: '600px',
      data: {
        'business_type_id': business_type_id,
        'business_type_name': business_type_name,
        'product_id': product_id,
        'product_name': product_name,
        'discount_price': discount_price,
        'update_for': 'product'
      },
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log('The dialog was closed');
      const res = result;
      console.log(res);
      if ((res !== null) && (res !== undefined)) {
        this.updateDiscountPrice(res);
        this.getBusinessWiseDiscountPriceDict();
      }
    });
  }

  discountPrice(business_type_id, product_id) {
    if (this.discount_price.hasOwnProperty(business_type_id)) {
      if (this.discount_price[business_type_id].hasOwnProperty(product_id)) {
        // console.log(this.discount_price[business_type_id][product_id]);
        return this.discount_price[business_type_id][product_id];
      } else {
        return 'N/A';
      }
    } else {
      return 'N/A';
    }
  }

  updateDiscountPrice(result) {
    console.log('update commission');
    if (this.discount_price.hasOwnProperty(result['business_type_id']) === false) {
      console.log('with in if');
      this.discount_price[result['business_type_id']] = {};
      this.discount_price[result['business_type_id']][result['product_id']] = result['discount_price'];
    } else {
      this.discount_price[result['business_type_id']][result['product_id']] = result['discount_price'];
    }
  }

}
